import { HTMLAttributes, PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import classNames from './styles.module.css';

export type ContainerProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

export const Container = ({ children, className, ...attributes }: ContainerProps) => (
  <div {...attributes} className={clsx(classNames.container, className)}>{children}</div>
);